import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queries } from '../../../../../shared/queries';
import { handleError } from '../../../../ui/err/handleError';
import { showSuccessNotification } from '../../../../ui/notification';

import type { AxiosCommonError } from '../../../../../shared/types';
import { prodoqApis } from '../../../../../shared/apis/prodoq/apis';

export default function usePatchProdoqCompany() {
  const queryClient = useQueryClient();

  return useMutation(prodoqApis.patchProdoqCompany, {
    onSuccess: () => {
      showSuccessNotification('변경되었습니다.');
      queryClient.invalidateQueries({ queryKey: queries.prodoq.companies._def });
    },
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
